const ENTRY_KEY = 'mocaEntryType';
const ENTRY_MAIN = 'main';
const ENTRY_ORG = 'org';

// MOCA 页面入口类型枚举：用于区分综合运营平台入口与机构入口
export const MocaEntryType = {
  MAIN: ENTRY_MAIN,
  ORG: ENTRY_ORG,
  KEY: ENTRY_KEY
};

// 将外部传入的入口值归一化，避免出现除 main/org 之外的非法值
export function normalizeEntryType(value) {
  return value === ENTRY_ORG ? ENTRY_ORG : ENTRY_MAIN;
}

// 将当前页面入口类型持久化到本地存储，供后续页面跳转与守卫复用
export function setMocaEntryType(entryType) {
  const normalized = normalizeEntryType(entryType);
  uni.setStorageSync(ENTRY_KEY, normalized);
  return normalized;
}

// 读取当前缓存的 MOCA 页面入口类型；未设置时默认按主系统入口处理
export function getMocaEntryType() {
  return normalizeEntryType(uni.getStorageSync(ENTRY_KEY));
}

// 解析页面 URL 参数中的入口信息，并同步保存机构上下文
export function parseMocaEntry(options = {}) {
  const entryType = normalizeEntryType(options.entry || options.entryType || options.source);
  const orgId = options.orgId || '';
  const orgName = options.orgName || '';
  const orgCode = options.orgCode || '';

  setMocaEntryType(entryType);
  if (orgId) uni.setStorageSync('mocaOrgId', orgId);
  if (orgName) uni.setStorageSync('mocaOrgName', orgName);
  if (orgCode) uni.setStorageSync('mocaOrgCode', orgCode);

  return { entryType, orgId, orgName, orgCode };
}

export function enterMocaOrgHomeByReplace() {
  // #ifdef H5
  if (typeof window === 'undefined') return false;

  const url = new URL(window.location.href);
  if (!url.pathname.includes('/pages/moca/index')) return false;
  if (url.searchParams.get('entry') !== ENTRY_ORG && url.searchParams.get('entryType') !== ENTRY_ORG) return false;
  if (url.searchParams.get('mocaReplaceEntry') === '1') return false;

  //replaceState 只改历史栈条目，不触发页面重载；原 location.replace 会导致整页刷新闪烁
  url.searchParams.set('entry', ENTRY_ORG);
  url.searchParams.set('mocaReplaceEntry', '1');
  history.replaceState(null, '', url.toString());
  // #endif

  return false;
}

// 获取当前缓存的机构基础信息，供首页头像展示与机构登录页回显使用
export function getMocaOrgInfo() {
  return {
    orgId: uni.getStorageSync('mocaOrgId') || '',
    orgName: uni.getStorageSync('mocaOrgName') || '',
    orgCode: uni.getStorageSync('mocaOrgCode') || '',
  };
}

// 统一圆屏判断：供登录页、首页等多个页面复用
export function isMocaRoundScreen() {
  const { windowWidth, windowHeight } = uni.getSystemInfoSync();
  return Math.abs(windowWidth - windowHeight) <= 20 && windowWidth >= 796 && windowWidth <= 836;
}
